import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeHtml'
})
export class DecodeHtmlPipe implements PipeTransform {

  transform(value: any): string {
    if (value == null) return value;
    return decodeURIComponent(value);
  }

}
